import axios from './axiosConfig';
import authHeader from "./auth-header";
import { API_URL } from "utils/constants";

/* Account Create Confirm */
const accountCreateConfirm = (uid, password) => {
  return axios.post(API_URL + "profile/account_create_confirm/", {
    uid,
    password: password,
  });
};

/* Profile My Info */
const getProfileInfo = () => {
  return axios.get(API_URL + "profile/me/info/", {
    headers: authHeader(),
  });
};

const getProfilePhoto = () => {
  return axios.get(API_URL + "profile/me/photo/", {
    headers: authHeader(),
  });
};

const getCurrentTimezone = () => {
  return axios.get(API_URL + "profile/timezone/", {
    headers: authHeader(),
  });
};

const changeTimezone = (timeZoneValue) => {
  return axios.patch(
    API_URL + "profile/timezone/",
    {
      timezone: timeZoneValue,
    },
    {
      headers: authHeader(),
    }
  );
};

/* Profile Teams */
const getProfileTeams = () => {
  return axios.get(API_URL + "profile/teams/", {
    headers: authHeader(),
  });
};

const changeProfileTeams = (id, name) => {
  return axios.put(
    API_URL + `profile/team/${id}`,
    {
      name,
    },
    {
      headers: authHeader(),
    }
  );
};

const addProfileTeam = (name, members) => {
  return axios.post(
    API_URL + `profile/team/add/`,
    {
      name,
      team_members: members,
    },
    {
      headers: authHeader(),
    }
  );
};

const deleteProfileTeam = (id) => {
  return axios.delete(API_URL + `profile/team/${id}/`, {
    headers: authHeader(),
  });
};

/* Profile Team Members */
const getProfileMembers = () => {
  return axios.get(API_URL + "profile/team_members/", {
    headers: authHeader(),
  });
};

const getProfileMemberById = (id) => {
  return axios.get(API_URL + `profile/team_member/${id}`, {
    headers: authHeader(),
  });
};

const addProfileMember = (data) => {
  return axios.post(API_URL + `profile/team_member/add/`, data, {
    headers: authHeader(),
  });
};

/* Edit Team Members */
const changeProfileMember = (id, data) => {
  return axios.patch(API_URL + `profile/team_member/${id}/`, data, {
    headers: authHeader(),
  });
};

const getBamboohrEmployees = () => {
  return axios.get(API_URL + "profile/bamboohr_employees", {
    headers: authHeader(),
  });
};

const deleteMemberAccount = (id) => {
  return axios.delete(API_URL + `profile/account_delete/${id}/`, {
    headers: authHeader(),
  });
};

/* Add Team Members */
const getSchedules = () => {
  return axios.get(API_URL + "profile/schedules/", {
    headers: authHeader(),
  });
};

const getEmails = () => {
  return axios.get(API_URL + "profile/emails/", {
    headers: authHeader(),
  });
};

const getRoles = () => {
  return axios.get(API_URL + "profile/roles/", {
    headers: authHeader(),
  });
};

const getAccountStatus = (id) => {
  return axios.get(API_URL + `profile/has_account/${id}`, {
    headers: authHeader(),
  });
};

const accountCreate = ({ email, role, id }) => {
  return axios.post(
    API_URL + "profile/account_create/",
    {
      email,
      role,
      employee_id: id,
    },
    {
      headers: authHeader(),
    }
  );
};

const getSmartTelId = (extension) => {
  return axios.get(API_URL + `parsers/get_smart_tel_id/${extension}/`, {
    headers: authHeader(),
  });
};

/* Add Schedule */
const addNewSchedule = async (newSchedule) => {
  try {
    const response = await axios.post(
      `${API_URL}profile/schedule/complete_add/`,
      newSchedule,
      {
        headers: authHeader(),
      },
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const editSchedule = async (editedSchedule) =>{
  try {
    const response = await axios.put(
      `${API_URL}profile/schedule/complete_add/`,
    
      editedSchedule,
      {
        headers: authHeader(),
      },
    )
    return response;
  } catch (error) {
    throw error;
  }
};

const addBreak = async (newBreak)=>{
  try {
    const response = await axios.post(
      `${API_URL}profile/break/add/`,

      newBreak,
      {
        headers: authHeader(),
      },
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const addWorkTimeForecasting = async (newWorkTimeForecasting)=>{
  try{const response = await axios.post(
    `${API_URL}profile/work_time_forecasting/add/`,

    newWorkTimeForecasting,
    {
      headers: authHeader(),
    },
  );
  return response;
} catch (error) {
  throw error;
}
};

const deleteSchedule = async (id) => {
  try {
    const response = await axios.delete(
      `${API_URL}profile/schedule/${id}/`,
      {
        headers: authHeader(),
      },
    );
    return response;
  } catch (error) {
    throw error;
  }
}

const userProfile = {
  accountCreateConfirm,
  getProfileInfo,
  getCurrentTimezone,
  getProfilePhoto,
  changeTimezone,
  getProfileTeams,
  changeProfileTeams,
  addProfileTeam,
  deleteProfileTeam,
  getProfileMembers,
  getProfileMemberById,
  addProfileMember,
  changeProfileMember,
  getBamboohrEmployees,
  deleteMemberAccount,
  getSchedules,
  getEmails,
  getRoles,
  getAccountStatus,
  accountCreate,
  getSmartTelId,
  addNewSchedule,
  editSchedule,
  addBreak,
  addWorkTimeForecasting,
  deleteSchedule,
};

export default userProfile;
